import { render } from "./DeveloperItemNote.vue?vue&type=template&id=2350c03e"
import script from "./DeveloperItemNote.vue?vue&type=script&lang=js"
export * from "./DeveloperItemNote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__